// removed by extract-text-webpack-plugin
module.exports = {"form":"preview-button__form___Vp9SI","button":"preview-button__button___DY3cq","container":"preview-button__container___20wIW","label":"preview-button__label___1UtXy"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/preview-button.css
// module id = 852
// module chunks = 0